export enum Permission {
  ExternalHealthDashboard = "external_health_dashboard.view",
}
